import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import SyswebVueComponents from 'sysweb-vue-components';
import { setAppVue } from 'sysweb-vue-components/src/global'

import Tooltip from '@programic/vue3-tooltip'
import '@programic/vue3-tooltip/dist/index.css';

import AppSpinner from '@Component/Spinner';
import CopyButton from '@/components/CopyButton';

const app = createApp(App);

app.component('app-spinner', AppSpinner)
app.component('app-copy-button', CopyButton)

app.use(SyswebVueComponents, {
  icon:{
      prefix: 'icon-',
      url: '/icones/icons.svg'
  }
});
app.use(router);
app.use(store);
app.use(Tooltip, {})

setAppVue(app);

app.mount('#app');